import { atom } from 'recoil';

export const user = atom({
  key: 'user',
  default: null,
});

export const authModal = atom({
  key: 'authModal',
  default: false,
});

export const userLocation = atom({
  key: 'location',
  default: null,
});

export const promoCode = atom({
  key: 'promoCode',
  default: null,
});
